import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_chevron-left",
  "use": "icon_chevron-left-usage",
  "viewBox": "0 0 24 25",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 25\" id=\"icon_chevron-left\"><path stroke=\"currentColor\" stroke-linecap=\"square\" d=\"m15 19.2539-7-7 7-6.99999\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol